/**
 * Open a URL in a separate tab without disturbing the current page.
 *
 * Used for the legal/policy links that sit inside a flow (deposit, signup):
 * target="_blank" alone is not enough, because in-app browsers and some
 * webviews ignore it and navigate the current document, which unloads the app
 * and wipes the progress the user made. So the default navigation is cancelled
 * and the tab is opened explicitly, with its opener severed so the policy tab
 * can never reach back into the flow it was launched from.
 *
 * Native browser behaviour is left alone for modifier / non-primary clicks so
 * "open in background tab" keeps working.
 */
export function openInNewTab(url, event) {
  if (event) {
    if (
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      (event.button != null && event.button !== 0)
    ) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  }

  const newTab = window.open(url, "_blank");
  if (newTab) newTab.opener = null;
  // window.open returns null only when the popup was blocked; fall back to a
  // normal visit so the link is never a dead click.
  else window.location.href = url;
}
